export default __webpack_public_path__ + "static/media/innovation.f8b22837.png";